import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import '../../Pages/Homepage.css';
import Navbar from '../../commonComponents/Navbar';
import TechPlatformBanner from '../../Componentsss/TechPlatform/TechPlatformBanner/TechPlatformBanner';
import TechCBT from '../../Componentsss/TechPlatform/TechCBT/TechCBT';
import TechApp from '../../Componentsss/TechPlatform/TechApp/TechApp';
import TechLastBanner from '../../Componentsss/TechPlatform/TechLastBanner/TechLastBanner';
import Footer from '../../commonComponents/Footer';
import OurClients from '../../Componentsss/TechPlatform/OurClients/OurClients';


const TechPlatform = () => {
  const location = useLocation();
  const TechCBTRef = useRef(null);
  const [hasScrolled, setHasScrolled] = useState(false);

  useEffect(() => {
    if (location.state?.scrollTo === 'TechCBT' && !hasScrolled) {
      setHasScrolled(true);
      setTimeout(() => {
        TechCBTRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 200); // Add delay to wait for full rendering
    }
  }, [location, hasScrolled]);



  const TechAppRef = useRef(null);


  useEffect(() => {
    if (location.state?.scrollTo === 'TechApp' && !hasScrolled) {
      setHasScrolled(true);
      setTimeout(() => {
        TechAppRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 200); // Add delay to wait for full rendering
    }
  }, [location, hasScrolled]);
  const [bannerLoaded, setBannerLoaded] = useState(false);

  return (
    <>
      {bannerLoaded && <Navbar />}
      <TechPlatformBanner onLoad={() => setBannerLoaded(true)}/>
      {bannerLoaded && (
      <>
        <div ref={TechCBTRef}><TechCBT /></div>
        <div ref={TechAppRef}> <TechApp /></div>
        <OurClients />
        <TechLastBanner />
        <Footer />
      </>
    )}
      
    </>
  );
};

export default TechPlatform;
